@if (incomeTaxEntity$ | async) {
  <form [formGroup]="formGroup">
    @if (gewoneGiften.length > 0) {
      <div formArrayName="gewoneGiften">
        @for (item of gewoneGiften.controls; track item; let i = $index) {
          <div [formGroupName]="i" class="row col-auto" style="--bs-gutter-x: 0.5rem;">
            <snelstart-ui-text-form-control
              [label]="i === 0 ? 'Omschrijving gewone gift' : ''"
              class="col-auto custom-input-250"
              formControlName="omschrijving"
              id="omschrijvingGewoon"
            >
            </snelstart-ui-text-form-control>
            <snelstart-ui-select-form-control
              [label]="i === 0 ? 'Culture ANBI?' : ''"
              [options]="optionsJaNee"
              [required]=true
              class="col-auto custom-input-150"
              formControlName="cultureleAnbi"
              id="cultureleAnbi-{{i}}"
            >
            </snelstart-ui-select-form-control>
            <snelstart-ui-number-form-control
              [decimals]="0"
              [label]="i === 0 ? 'Bedrag' : ''"
              [required]=true
              align="right"
              class="col-auto custom-input-150"
              formControlName="bedrag"
              id="bedragGewoon"
              prefix="€"
            >
            </snelstart-ui-number-form-control>
            <snelstart-ui-button id="buttonDeleteKosten"
                                 type="secondary"
                                 size="medium"
                                 icon="trash"
                                 (click)="verwijderRij(i)"
                                 [class]="i === 0 ? 'firstrowbutton col-auto ' : 'col-auto '"
            >
            </snelstart-ui-button>
          </div>
        }
      </div>
    }
  </form>
}

<snelstart-ui-button class="snelstart-ui-button pb-3" type="link" icon="plus"
                     (click)="addRij()">Gewone gift toevoegen
</snelstart-ui-button>
